import React from 'react'
import _ from 'underscore'
import { Ban } from 'lucide-react'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import Textarea from '../textarea'
import Input from '../input'
import SelectTemplate from './select_template'

class WhatsappComposer extends React.Component {

  onSend = () => {
    this.props.onSend()
  }

  onChange = (params = {}) => {
    let whatsapp

    if (this.props.whatsapp.toJS) {
      whatsapp = this.props.whatsapp.toJS() || {}
    }
    else {
      whatsapp = this.props.whatsapp || {}
    }

    whatsapp = _.extend(whatsapp, params)

    this.props.onChange({
      content: whatsapp.content || ''
    })
  }

  onContentChange = (value) => {
    this.onChange({content: value})
  }

  onTemplateChange = (value) => {
    this.props.onTemplateChange(value)
  }

  onVariableChange = (key, value) => {
    this.props.onVariableChange(key, value)
  }

  render() {
    const whatsapp = this.props.whatsapp || {}
    const content = whatsapp.content || ''
    const variables = whatsapp.variables || {}

    let interpolatedContent = content
    let canSend = true

    if (_.isEmpty(this.props.template_name)) {
      canSend = false
    }

    if (_.isEmpty(interpolatedContent)) {
      canSend = false
    }

    _.each(_.keys(variables), function(key) {
      interpolatedContent = interpolatedContent.replace(key, variables[key] || key)

      if (_.isEmpty(variables[key])) {
        canSend = false
      }
    })

    return (
      <div className="grid gap-4">
        <div className="grid gap-2">
          <Label>To</Label>
          <div className="flex flex-wrap items-center gap-2">
            <span className="text-sm">{whatsapp.to}</span>
            {this.props.whatsapp_window_open === true &&
              <Badge variant="success" title="The recipient messaged us in the last 24 hours. Freeform (Draft) messages can be sent.">24h window open</Badge>
            }
            {this.props.whatsapp_window_open === false &&
              <Badge variant="warning" title="The recipient hasn't messaged us in the last 24 hours. Only approved template messages can be sent.">Window closed — template required</Badge>
            }
          </div>
        </div>
        <div className="grid gap-2">
          <Label>Template</Label>
          <div className="flex flex-wrap items-center gap-2">
            {this.props.template_name ?
              <span className="text-sm">{this.props.template_name}</span>
              : null
            }
            <SelectTemplate
              templates={this.props.templates}
              onSelect={this.onTemplateChange}
              disableDraft={this.props.whatsapp_window_open === false}
            />
          </div>
        </div>
        <div className="grid gap-2">
          <Label>Content</Label>
          {(this.props.template_name === 'draft') ?
            <React.Fragment>
              <Textarea rows="10" value={content || ''} onChange={this.onContentChange} placeholder="Type your message" expands={true}/>
              <span className="text-xs text-muted-foreground">Note that freeform messages can only be sent within a 24-hour window of the recipient having messaged us.</span>
            </React.Fragment>
          :
            <div className="whitespace-pre-wrap rounded-[10px] border border-border bg-muted/30 p-4 text-sm">{interpolatedContent}</div>
          }
        </div>
        {(this.props.template_name !== 'draft') ?
          _.map(_.keys(variables), (key) => {
            return (
              <div className="grid gap-2" key={key}>
                <Label>{key}</Label>
                <Input type="text" value={variables[key]} onChange={(value) => this.onVariableChange(key, value)}/>
              </div>
            )
          })
          : null
        }
        <div className="flex justify-end gap-2">
          {canSend ?
            <Button size="sm" onClick={this.onSend}>Send</Button>
          :
            <Button size="sm" disabled onClick={this.onSend}><Ban className="size-4"/> Send</Button>
          }
        </div>
      </div>
    )
  }
}

export default WhatsappComposer
